// // // // // import { useState } from 'react';
// // // // // import { Link } from 'react-router-dom';

// // // // // export default function Header() {
// // // // //   const [isMenuOpen, setIsMenuOpen] = useState(false);

// // // // //   return (
// // // // //     <header className="bg-white shadow-sm sticky top-0 z-50">
// // // // //       <nav className="max-w-6xl mx-auto px-4">
// // // // //         <div className="flex justify-between items-center h-16">
// // // // //           <div className="text-2xl font-heading font-bold text-primary-base">Capital Offset</div>
          
// // // // //           {/* Desktop Menu */}
// // // // //           <div className="hidden md:flex space-x-8">
// // // // //             <Link to="/" className={`text-gray-600 font-medium hover:text-primary-dark`}>Home</Link>
// // // // //             <Link to="/services" className={`text-gray-600 font-medium hover:text-primary-dark`}>Services</Link>
// // // // //             <Link to="/contact" className={`text-gray-600 font-medium hover:text-primary-dark`}>Contact Us</Link>

// // // // //           </div>
          
// // // // //           {/* Mobile Menu Button */}
// // // // //           <button 
// // // // //             className="md:hidden p-2"
// // // // //             onClick={() => setIsMenuOpen(!isMenuOpen)}
// // // // //           >
// // // // //             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// // // // //               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
// // // // //             </svg>
// // // // //           </button>
// // // // //         </div>
        
// // // // //         {/* Mobile Menu */}
// // // // //         {isMenuOpen && (
// // // // //           <div className="md:hidden absolute bg-white w-full left-0 px-4 pb-4 shadow-md">
// // // // //             <Link to="/" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Home</Link>
// // // // //             <Link to="/services" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Services</Link>
// // // // //             <Link to="/contact" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Contact Us</Link>
// // // // //           </div>
// // // // //         )}
// // // // //       </nav>
// // // // //     </header>
// // // // //   )
// // // // // }

// // // // import { useState } from 'react';
// // // // import { Link } from 'react-router-dom';

// // // // export default function Header() {
// // // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // // //   const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);

// // // //   return (
// // // //     <header className="bg-white shadow-sm sticky top-0 z-50">
// // // //       <nav className="max-w-6xl mx-auto px-4">
// // // //         <div className="flex justify-between items-center h-16">
// // // //           <div className="text-2xl font-heading font-bold text-primary-base">Capital Offset</div>
          
// // // //           {/* Desktop Menu */}
// // // //           <div className="hidden md:flex space-x-8 relative">
// // // //             <Link to="/" className={`text-gray-600 font-medium hover:text-primary-dark`}>Home</Link>

// // // //             {/* Services Dropdown */}
// // // //             <div
// // // //               className="relative"
// // // //               onMouseEnter={() => setIsServicesDropdownOpen(true)}
// // // //               onMouseLeave={() => setIsServicesDropdownOpen(false)}
// // // //             >
// // // //               <Link
// // // //                 to="/services"
// // // //                 className={`text-gray-600 font-medium hover:text-primary-dark`}
// // // //               >
// // // //                 Services
// // // //               </Link>
// // // //               {isServicesDropdownOpen && (
// // // //                 <div className="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-lg">
// // // //                   <Link
// // // //                     to="/service1"
// // // //                     className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
// // // //                   >
// // // //                     Service 1
// // // //                   </Link>
// // // //                   <Link
// // // //                     to="/service2"
// // // //                     className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
// // // //                   >
// // // //                     Service 2
// // // //                   </Link>
// // // //                   <Link
// // // //                     to="/service3"
// // // //                     className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
// // // //                   >
// // // //                     Service 3
// // // //                   </Link>
// // // //                 </div>
// // // //               )}
// // // //             </div>

// // // //             <Link to="/contact" className={`text-gray-600 font-medium hover:text-primary-dark`}>Contact Us</Link>
// // // //           </div>
          
// // // //           {/* Mobile Menu Button */}
// // // //           <button 
// // // //             className="md:hidden p-2"
// // // //             onClick={() => setIsMenuOpen(!isMenuOpen)}
// // // //           >
// // // //             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// // // //               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
// // // //             </svg>
// // // //           </button>
// // // //         </div>
        
// // // //         {/* Mobile Menu */}
// // // //         {isMenuOpen && (
// // // //           <div className="md:hidden absolute bg-white w-full left-0 px-4 pb-4 shadow-md">
// // // //             <Link to="/" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Home</Link>
// // // //             <div className="relative">
// // // //               <Link to="/services" className={`block py-2 text-gray-600 hover:text-primary-dark`}>
// // // //                 Services
// // // //               </Link>
// // // //               <div className="absolute left-0 w-full mt-2 bg-white shadow-lg rounded-lg">
// // // //                 <Link
// // // //                   to="/service1"
// // // //                   className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
// // // //                 >
// // // //                   Service 1
// // // //                 </Link>
// // // //                 <Link
// // // //                   to="/service2"
// // // //                   className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
// // // //                 >
// // // //                   Service 2
// // // //                 </Link>
// // // //                 <Link
// // // //                   to="/service3"
// // // //                   className="block py-2 px-4 text-gray-600 hover:bg-gray-100 hover:text-primary-dark"
// // // //                 >
// // // //                   Service 3
// // // //                 </Link>
// // // //               </div>
// // // //             </div>
// // // //             <Link to="/contact" className={`block py-2 text-gray-600 hover:text-primary-dark`}>Contact Us</Link>
// // // //           </div>
// // // //         )}
// // // //       </nav>
// // // //     </header>
// // // //   );
// // // // }
// // // import { useState } from 'react';
// // // import { Link } from 'react-router-dom';
// // // import logo from '../assets/capitalPlus.png';

// // // export default function Header() {
// // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // //   const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
// // //   const [activeTab, setActiveTab] = useState('services');

// // //   const toggleMenu = () => {
// // //     setIsMenuOpen(!isMenuOpen);
// // //   };

// // //   return (
// // //     <nav className="bg-transparent text-sky-900 backdrop-blur-lg p-4 fixed top-0 left-0 w-full z-10">
// // //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// // //         <div className="flex items-center justify-between h-16">
// // //           <div className="flex items-center">
// // //             <div className="flex-shrink-0">
// // //               <img
// // //                 src={logo}
// // //                 alt="Capital Offset Logo"
// // //                 className="h-20 w-auto" // Adjust the size as needed
// // //               />
// // //             </div>
// // //             <div className="hidden md:block">
// // //               <div className="ml-10 flex items-baseline space-x-4">
// // //                 <Link to="/" className="px-3 py-2 rounded-md text-sm font-medium bg-indigo-800 text-white">
// // //                   Home
// // //                 </Link>
// // //                 <Link
// // //                   to="/services"
// // //                   className="px-3 py-2 rounded-md text-sm font-medium text-gray-800 hover:bg-indigo-700 hover:text-white"
// // //                 >
// // //                   Services
// // //                 </Link>
// // //                 <Link
// // //                   to="/solutions"
// // //                   className="px-3 py-2 rounded-md text-sm font-medium text-gray-800 hover:bg-indigo-700 hover:text-white"
// // //                 >
// // //                   Solutions
// // //                 </Link>
// // //                 <Link
// // //                   to="/about"
// // //                   className="px-3 py-2 rounded-md text-sm font-medium text-gray-800 hover:bg-indigo-700 hover:text-white"
// // //                 >
// // //                   About
// // //                 </Link>
// // //                 <Link
// // //                   to="/contact"
// // //                   className="px-3 py-2 rounded-md text-sm font-medium text-gray-800 hover:bg-indigo-700 hover:text-white"
// // //                 >
// // //                   Contact
// // //                 </Link>
// // //               </div>
// // //             </div>
// // //           </div>
// // //           <div className="md:hidden">
// // //             <button
// // //               onClick={toggleMenu}
// // //               className="inline-flex items-center justify-center p-2 rounded-md text-gray-200 hover:text-white hover:bg-indigo-700 focus:outline-none"
// // //             >
// // //               <span className="sr-only">Open main menu</span>
// // //               <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// // //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
// // //               </svg>
// // //             </button>
// // //           </div>
// // //         </div>
// // //       </div>

// // //       {/* Mobile menu */}
// // //       {isMenuOpen && (
// // //         <div className="md:hidden">
// // //           <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
// // //             <Link
// // //               to="/"
// // //               className="block px-3 py-2 rounded-md text-base font-medium bg-indigo-800 text-white"
// // //             >
// // //               Home
// // //             </Link>
// // //             <Link
// // //               to="/services"
// // //               className="block px-3 py-2 rounded-md text-base font-medium text-gray-800 hover:bg-indigo-700 hover:text-white"
// // //             >
// // //               Services
// // //             </Link>
// // //             <Link
// // //               to="/solutions"
// // //               className="block px-3 py-2 rounded-md text-base font-medium text-gray-800 hover:bg-indigo-700 hover:text-white"
// // //             >
// // //               Solutions
// // //             </Link>
// // //             <Link
// // //               to="/about"
// // //               className="block px-3 py-2 rounded-md text-base font-medium text-gray-800 hover:bg-indigo-700 hover:text-white"
// // //             >
// // //               About
// // //             </Link>
// // //             <Link
// // //               to="/contact"
// // //               className="block px-3 py-2 rounded-md text-base font-medium text-gray-800 hover:bg-indigo-700 hover:text-white"
// // //             >
// // //               Contact
// // //             </Link>
// // //           </div>
// // //         </div>
// // //       )}
// // //     </nav>
// // //   );
// // // }



// // import { useState } from 'react';
// // import { Link, useLocation } from 'react-router-dom';
// // import logo from '../assets/capitalPlus.png';

// // export default function Header() {
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// //   const location = useLocation(); // Get the current location

// //   const toggleMenu = () => {
// //     setIsMenuOpen(!isMenuOpen);
// //   };

// //   // Function to check if the link is active
// //   const isActive = (path) => location.pathname === path;

// //   return (
// //     <nav className="bg-white text-sky-900 backdrop-blur-lg px-4 py-2 top-0 left-0 w-full z-10">
// //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //         <div className="flex items-center justify-between h-16">
// //           <div className="flex items-center">
// //             <div className="flex-shrink-0">
// //               <img
// //                 src={logo}
// //                 alt="Capital Offset Logo"
// //                 className="h-20 w-auto" // Adjust the size as needed
// //               />
// //             </div>
// //             <div className="hidden md:block">
// //               <div className="ml-10 flex items-baseline space-x-4">
// //                 <Link
// //                   to="/"
// //                   className={`px-3 py-2 rounded-md text-sm font-medium ${
// //                     isActive('/') ? 'bg-indigo-800 text-white' : 'text-gray-800 hover:bg-indigo-700 hover:text-white'
// //                   }`}
// //                 >
// //                   Home
// //                 </Link>
// //                 <Link
// //                   to="/services"
// //                   className={`px-3 py-2 rounded-md text-sm font-medium ${
// //                     isActive('/services') ? 'bg-indigo-800 text-white' : 'text-gray-800 hover:bg-indigo-700 hover:text-white'
// //                   }`}
// //                 >
// //                   Services
// //                 </Link>
// //                 <Link
// //                   to="/solutions"
// //                   className={`px-3 py-2 rounded-md text-sm font-medium ${
// //                     isActive('/solutions') ? 'bg-indigo-800 text-white' : 'text-gray-800 hover:bg-indigo-700 hover:text-white'
// //                   }`}
// //                 >
// //                   Solutions
// //                 </Link>
// //                 <Link
// //                   to="/about"
// //                   className={`px-3 py-2 rounded-md text-sm font-medium ${
// //                     isActive('/about') ? 'bg-indigo-800 text-white' : 'text-gray-800 hover:bg-indigo-700 hover:text-white'
// //                   }`}
// //                 >
// //                   About
// //                 </Link>
// //                 <Link
// //                   to="/contact"
// //                   className={`px-3 py-2 rounded-md text-sm font-medium ${
// //                     isActive('/contact') ? 'bg-indigo-800 text-white' : 'text-gray-800 hover:bg-indigo-700 hover:text-white'
// //                   }`}
// //                 >
// //                   Contact
// //                 </Link>
// //               </div>
// //             </div>
// //           </div>
// //           <div className="md:hidden">
// //             <button
// //               onClick={toggleMenu}
// //               className="inline-flex items-center justify-center p-2 rounded-md text-gray-200 hover:text-white hover:bg-indigo-700 focus:outline-none"
// //             >
// //               <span className="sr-only">Open main menu</span>
// //               <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
// //                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
// //               </svg>
// //             </button>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Mobile menu */}
// //       {isMenuOpen && (
// //         <div className="md:hidden">
// //           <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
// //             <Link
// //               to="/"
// //               className={`block px-3 py-2 rounded-md text-base font-medium ${
// //                 isActive('/') ? 'bg-indigo-800 text-white' : 'text-gray-800 hover:bg-indigo-700 hover:text-white'
// //               }`}
// //             >
// //               Home
// //             </Link>
// //             <Link
// //               to="/services"
// //               className={`block px-3 py-2 rounded-md text-base font-medium ${
// //                 isActive('/services') ? 'bg-indigo-800 text-white' : 'text-gray-800 hover:bg-indigo-700 hover:text-white'
// //               }`}
// //             >
// //               Services
// //             </Link>
// //             <Link
// //               to="/solutions"
// //               className={`block px-3 py-2 rounded-md text-base font-medium ${
// //                 isActive('/solutions') ? 'bg-indigo-800 text-white' : 'text-gray-800 hover:bg-indigo-700 hover:text-white'
// //               }`}
// //             >
// //               Solutions
// //             </Link>
// //             <Link
// //               to="/about"
// //               className={`block px-3 py-2 rounded-md text-base font-medium ${
// //                 isActive('/about') ? 'bg-indigo-800 text-white' : 'text-gray-800 hover:bg-indigo-700 hover:text-white'
// //               }`}
// //             >
// //               About
// //             </Link>
// //             <Link
// //               to="/contact"
// //               className={`block px-3 py-2 rounded-md text-base font-medium ${
// //                 isActive('/contact') ? 'bg-indigo-800 text-white' : 'text-gray-800 hover:bg-indigo-700 hover:text-white'
// //               }`}
// //             >
// //               Contact
// //             </Link>
// //           </div>
// //         </div>
// //       )}
// //     </nav>
// //   );
// // }

// import React, { useState, useRef, useEffect } from 'react';
// import logo from '../assets/capitalPlus.png';

// const Header = () => {
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const dropdownRefs = useRef([]);
  
//   // Add event listeners for better dropdown control
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (activeDropdown !== null && 
//           dropdownRefs.current[activeDropdown] && 
//           !dropdownRefs.current[activeDropdown].contains(event.target)) {
//         setActiveDropdown(null);
//       }
//     };
    
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [activeDropdown]);

//   // Initialize dropdown refs
//   useEffect(() => {
//     dropdownRefs.current = dropdownRefs.current.slice(0, navItems.length);
//   }, []);
  
//   const navItems = [
//     {
//       title: 'Platform',
//       dropdown: [
//         {
//           section: 'Features',
//           icon: 'feature',
//           items: [
//             { title: 'Platform Overview', description: 'Explore the entire platform', icon: 'globe' },
//             { title: 'Automated Provisioning', description: 'Efficient and scalable resource management', icon: 'automation' },
//             { title: 'Cloud Services', description: 'Streamlined Multi-Cloud Service Management', icon: 'cloud' },
//             { title: 'CI / CD', description: 'Efficient CI / CD for Streamlined Development', icon: 'code' }
//           ]
//         },
//         {
//           section: 'Security',
//           icon: 'security',
//           items: [
//             { title: 'Security', description: 'Round-the-clock security and compliance', icon: 'shield' },
//             { title: 'Compliance', description: 'Delivering out-of-the-box compliance controls', icon: 'check-shield' },
//             { title: 'Diagnostics & Monitoring', description: 'Optimize performance with real-time monitoring', icon: 'chart' },
//             { title: 'Advanced Observability Suite', description: 'Deeper insights into application performance', icon: 'eye' }
//           ]
//         },
//         {
//           section: 'For Teams',
//           icon: 'team',
//           items: [
//             { title: 'Developers', description: 'Self-service efficiency for empowered developers', icon: 'code-box' },
//             { title: 'IT Professionals', description: 'Tailored automation for IT excellence', icon: 'settings' }
//           ]
//         }
//       ]
//     },
//     {
//       title: 'Use Cases',
//       dropdown: [
//         {
//           section: 'Popular Cases',
//           icon: 'case',
//           items: [
//             { title: 'Enterprise Solutions', description: 'Scalable solutions for enterprise needs', icon: 'building' },
//             { title: 'Startup Acceleration', description: 'Fast-track your startup development', icon: 'rocket' }
//           ]
//         }
//       ]
//     },
//     {
//       title: 'Why Us',
//       dropdown: [
//         {
//           section: 'Our Advantages',
//           icon: 'star',
//           items: [
//             { title: 'Cost Efficiency', description: 'Save resources while maximizing output', icon: 'dollar' },
//             { title: 'Expert Support', description: '24/7 dedicated support team', icon: 'headset' },
//             { title: 'Success Stories', description: 'See how our customers succeed', icon: 'trophy' }
//           ]
//         }
//       ]
//     },
//     { title: 'Pricing', dropdown: [] },
//     {
//       title: 'Resources',
//       dropdown: [
//         {
//           section: 'Learning',
//           icon: 'book',
//           items: [
//             { title: 'Documentation', description: 'Comprehensive guides and references', icon: 'file-text' },
//             { title: 'Tutorials', description: 'Step-by-step learning resources', icon: 'video' },
//             { title: 'Blog', description: 'Latest updates and industry insights', icon: 'rss' }
//           ]
//         }
//       ]
//     }
//   ];

//   const toggleDropdown = (index) => {
//     setActiveDropdown(activeDropdown === index ? null : index);
//   };

//   const handleMouseEnter = (index) => {
//     setActiveDropdown(index);
//   };

//   const handleMouseLeave = () => {
//     // Using a slight delay to prevent instant closing
//     setTimeout(() => {
//       if (!dropdownRefs.current[activeDropdown]?.matches(':hover')) {
//         setActiveDropdown(null);
//       }
//     }, 100);
//   };

//   // Function to render appropriate icon based on icon name
//   const renderIcon = (iconName) => {
//     switch (iconName) {
//       case 'feature':
//         return (
//           <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
//             <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
//           </svg>
//         );
//       case 'security':
//         return (
//           <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
//             <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//           </svg>
//         );
//       case 'team':
//         return (
//           <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
//             <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
//           </svg>
//         );
//       case 'globe':
//         return (
//           <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
//             <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z" clipRule="evenodd" />
//           </svg>
//         );
//       // Add more icons for other cases
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="w-full bg-white shadow-md z-50 sticky top-0 border-b border-gray-100">
//       <div className="container mx-auto px-4">
//         <div className="flex items-center justify-between h-20">
//           {/* Logo */}
//           <div className="flex items-center">
//           <div className="flex-shrink-0">
//                <img
//                  src={logo}
//                  alt="Capital Offset Logo"
//                  className="h-20 w-auto" // Adjust the size as needed
//                />
//              </div>
//           </div>

//           {/* Navigation */}
//           <div className="hidden lg:block">
//             <div className="flex items-center space-x-1">
//               {navItems.map((item, index) => (
//                 <div
//                   key={index}
//                   className="relative"
//                   ref={el => dropdownRefs.current[index] = el}
//                   onMouseEnter={() => handleMouseEnter(index)}
//                   onMouseLeave={handleMouseLeave}
//                 >
//                   <button
//                     className={`px-4 py-2 rounded-md text-gray-700 hover:text-blue-600 font-medium flex items-center transition-colors duration-200 ${activeDropdown === index ? 'text-blue-600 bg-blue-50' : ''}`}
//                     onClick={() => toggleDropdown(index)}
//                   >
//                     {item.title}
//                     {item.dropdown.length > 0 && (
//                       <svg 
//                         xmlns="http://www.w3.org/2000/svg" 
//                         className={`ml-1 h-4 w-4 transition-transform duration-200 ${activeDropdown === index ? 'transform rotate-180' : ''}`} 
//                         fill="none" 
//                         viewBox="0 0 24 24" 
//                         stroke="currentColor"
//                       >
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                       </svg>
//                     )}
//                   </button>
                  
//                   {/* Dropdown Menu */}
//                   {item.dropdown.length > 0 && activeDropdown === index && (
//                     <div className="absolute left-0 mt-2 w-max bg-white rounded-lg shadow-xl z-50 overflow-hidden border border-gray-100 transform transition-all duration-300 origin-top-left">
//                       <div className="grid grid-cols-3 gap-0 p-2">
//                         {item.dropdown.map((section, sectionIndex) => (
//                           <div key={sectionIndex} className="p-4 hover:bg-gray-50 rounded-md transition-colors duration-200">
//                             <div className="flex items-center mb-4">
//                               <div className="flex-shrink-0 w-8 h-8 rounded-md bg-blue-100 flex items-center justify-center mr-3">
//                                 <span className="text-blue-600">
//                                   {renderIcon(section.icon)}
//                                 </span>
//                               </div>
//                               <span className="text-blue-600 font-semibold">{section.section}</span>
//                             </div>
//                             <div className="space-y-4">
//                               {section.items.map((subItem, subIndex) => (
//                                 <a 
//                                   key={subIndex} 
//                                   href="#" 
//                                   className="block group hover:bg-blue-50 p-2 rounded-md transition-colors duration-200"
//                                 >
//                                   <div className="flex">
//                                     <div className="mr-3 flex-shrink-0">
//                                       {renderIcon(subItem.icon)}
//                                     </div>
//                                     <div>
//                                       <p className="text-gray-800 font-medium group-hover:text-blue-600 transition-colors duration-200">{subItem.title}</p>
//                                       <p className="text-gray-500 text-sm mt-1">{subItem.description}</p>
//                                     </div>
//                                   </div>
//                                 </a>
//                               ))}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Mobile menu button */}
//           <div className="lg:hidden">
//             <button className="text-gray-700 hover:text-blue-600">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//               </svg>
//             </button>
//           </div>

//           {/* CTA Button */}
//           <div>
//             <button className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-bold py-3 px-8 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
//               GET STARTED
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Header;

import React, { useState, useRef, useEffect } from 'react';
import logo from '../assets/capitalPlus.png';
import { Link } from 'react-router-dom';

const Header = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [hoverIntent, setHoverIntent] = useState(null);
  const dropdownRefs = useRef([]);
  const hoverTimeoutRef = useRef(null);
  
  useEffect(() => {
    // Handle clicks outside of the dropdown
    const handleClickOutside = (event) => {
      if (activeDropdown !== null && 
          !dropdownRefs.current[activeDropdown]?.contains(event.target)) {
        setActiveDropdown(null);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activeDropdown]);

  // Clear timeout on unmount
  useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };
  }, []);

  // When hoverIntent changes, update activeDropdown after a short delay
  useEffect(() => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    
    if (hoverIntent !== null) {
      hoverTimeoutRef.current = setTimeout(() => {
        setActiveDropdown(hoverIntent);
      }, 100); // Short delay for hover intent
    }
  }, [hoverIntent]);
  
  const navItems = [
    // {
    //   title: 'Platform',
    //   dropdown: [
    //     {
    //       section: 'Features',
    //       icon: 'feature',
    //       items: [
    //         { title: 'Platform Overview', description: 'Explore the entire platform', icon: 'globe' },
    //         { title: 'Automated Provisioning', description: 'Efficient and scalable resource management', icon: 'automation' },
    //         { title: 'Cloud Services', description: 'Streamlined Multi-Cloud Service Management', icon: 'cloud' },
    //         { title: 'CI / CD', description: 'Efficient CI / CD for Streamlined Development', icon: 'code' }
    //       ]
    //     },
    //     {
    //       section: 'Security',
    //       icon: 'security',
    //       items: [
    //         { title: 'Security', description: 'Round-the-clock security and compliance', icon: 'shield' },
    //         { title: 'Compliance', description: 'Delivering out-of-the-box compliance controls', icon: 'check-shield' },
    //         { title: 'Diagnostics & Monitoring', description: 'Optimize performance with real-time monitoring', icon: 'chart' },
    //         { title: 'Advanced Observability Suite', description: 'Deeper insights into application performance', icon: 'eye' }
    //       ]
    //     },
    //     {
    //       section: 'For Teams',
    //       icon: 'team',
    //       items: [
    //         { title: 'Developers', description: 'Self-service efficiency for empowered developers', icon: 'code-box' },
    //         { title: 'IT Professionals', description: 'Tailored automation for IT excellence', icon: 'settings' }
    //       ]
    //     }
    //   ]
    // },
    { title: 'About Us', dropdown: [], link:'/about' },
    { title: 'Services', dropdown: [], link:'/services' },
    
    {
      title: 'Use Cases',
      dropdown: [
        {
          section: 'Popular Cases',
          icon: 'case',
          items: [
            { title: 'DevOps Automation', description: 'Increase DevOps efficiency and reduce costs', icon: 'building', link:'/devops-automation' },
            { title: 'Cloud Migration', description: 'Automate cloud based application deployments', icon: 'cloud', link:'/cloud-migration'},
            { title: 'Compliance and Security', description: 'Speed up compliance and strengthen your security posture', icon: 'code', link:'/compliance-security'},
          ]
        },
        {
          section: 'Platforms',
          icon: 'case',
          items: [
            { title: 'AWS', description: '', icon: 'cloud', link:'/platforms' },
            { title: 'GCP', description: '', icon: 'rocket', link:'/platforms' },
            { title: 'Azure', description: '', icon: 'rocket', link:'/platforms' },

          ]
        },
      ],

    },
    // {
    //   title: 'Why Us',
    //   dropdown: [
    //     {
    //       section: 'Our Advantages',
    //       icon: 'star',
    //       items: [
    //         { title: 'Cost Efficiency', description: 'Save resources while maximizing output', icon: 'dollar' },
    //         { title: 'Expert Support', description: '24/7 dedicated support team', icon: 'headset' },
    //         { title: 'Success Stories', description: 'See how our customers succeed', icon: 'trophy' }
    //       ]
    //     }
    //   ]
    // },
    { title: 'Pricing', dropdown: [], link:'/pricing' },

    // {
    //   title: 'Resources',
    //   dropdown: [
    //     {
    //       section: 'Learning',
    //       icon: 'book',
    //       items: [
    //         { title: 'Documentation', description: 'Comprehensive guides and references', icon: 'file-text',  },
    //         { title: 'Tutorials', description: 'Step-by-step learning resources', icon: 'video' },
    //         { title: 'Blog', description: 'Latest updates and industry insights', icon: 'rss' }
    //       ]
    //     }
    //   ]
    // }
  ];

  // Click toggle
  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  // Mouse enter with intent tracking
  const handleMouseEnter = (index) => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    setHoverIntent(index);
  };

  // Mouse leave with delayed closing
  const handleMouseLeave = (index) => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
    }
    
    hoverTimeoutRef.current = setTimeout(() => {
      if (hoverIntent === index) {
        setHoverIntent(null);
        setActiveDropdown(null);
      }
    }, 300); // Longer delay when leaving to prevent accidental closing
  };

  // Function to render appropriate icon based on icon name
  const renderIcon = (iconName) => {
    switch (iconName) {
      case 'feature':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clipRule="evenodd" />
          </svg>
        );
      case 'security':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
        );
      case 'team':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
          </svg>
        );
      case 'globe':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.083 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z" clipRule="evenodd" />
          </svg>
        );
      // Default case
      default:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm3 1h6v4H7V5zm8 8v2h1v1H4v-1h1v-2a1 1 0 011-1h8a1 1 0 011 1z" clipRule="evenodd" />
          </svg>
        );
    }
  };

  return (
    <div className="w-full bg-white shadow-md z-50 top-0 border-b border-gray-100">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
          <Link to='/'>
          <div className="flex-shrink-0">
               <img
                 src={logo}
                 alt="Capital Offset Logo"
                 className="h-20 w-auto" // Adjust the size as needed
               />
             </div>
             </Link>
          </div>

          {/* Navigation */}
          <div className="hidden lg:block">
            <div className="flex items-center space-x-1">
              {navItems.map((item, index) => (
                <div
                  key={index}
                  className="relative"
                  ref={el => dropdownRefs.current[index] = el}
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={() => handleMouseLeave(index)}
                >
                  <Link to={item.link}>
                  <button
                    className={`px-4 py-2 rounded-md text-gray-700 hover:text-blue-600 font-medium flex items-center transition-colors duration-200 ${activeDropdown === index ? 'text-blue-600 bg-blue-50' : ''}`}
                    onClick={() => toggleDropdown(index)}
                    aria-expanded={activeDropdown === index}
                  >
                    {item.title}
                    {item.dropdown.length > 0 && (
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        className={`ml-1 h-4 w-4 transition-transform duration-200 ${activeDropdown === index ? 'transform rotate-180' : ''}`} 
                        fill="none" 
                        viewBox="0 0 24 24" 
                        stroke="currentColor"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    )}
                  </button>
                  </Link>

                  {/* Dropdown Menu */}
                  {item.dropdown.length > 0 && (
                    <div 
                      className={`absolute left-0 mt-2 w-max bg-white rounded-lg shadow-xl z-50 overflow-hidden border border-gray-100 transition-all duration-300 origin-top-left ${
                        activeDropdown === index 
                          ? 'opacity-100 transform scale-100 pointer-events-auto' 
                          : 'opacity-0 transform scale-95 pointer-events-none'
                      }`}
                    >
                      <div className="grid grid-cols-2 gap-0 p-2">
                        {item.dropdown.map((section, sectionIndex) => (
                          <div key={sectionIndex} className="p-4 hover:bg-gray-50 rounded-md transition-colors duration-200">
                            <div className="flex items-center mb-4">
                              <div className="flex-shrink-0 w-8 h-8 rounded-md bg-blue-100 flex items-center justify-center mr-3">
                                <span className="text-blue-600">
                                  {renderIcon(section.icon)}
                                </span>
                              </div>
                              <span className="text-blue-600 font-semibold">{section.section}</span>
                            </div>
                            <div className="space-y-4">
                              {section.items.map((subItem, subIndex) => (
                                <a 
                                  key={subIndex} 
                                  href={subItem.link}
                                  className="block group hover:bg-blue-50 p-2 rounded-md transition-colors duration-200"
                                >
                                  <div className="flex">
                                    <div className="mr-3 flex-shrink-0">
                                      {renderIcon(subItem.icon)}
                                    </div>
                                    <div>
                                      <p className="text-gray-800 font-medium group-hover:text-blue-600 transition-colors duration-200">{subItem.title}</p>
                                      <p className="text-gray-500 text-sm mt-1">{subItem.description}</p>
                                    </div>
                                  </div>
                                </a>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button className="text-gray-700 hover:text-blue-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>

          {/* CTA Button */}
          <div>
            <Link to='/contact'>
            <button className="bg-gradient-to-r from-blue-500 to-violet-600 hover:from-blue-600 hover:to-violet-700 text-white font-bold py-3 px-8 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
              GET STARTED
            </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;

